export const copyright = (): void => {
  const year = document.querySelector('.copyright-year') as HTMLElement;
  year.textContent = new Date().getFullYear().toString();
};
